import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { StarRating } from '../ui/StarRating';
import { useReviewForm } from '../../hooks/useReviewForm';
import { StoreReviewableProduct } from '../../models';
import { safeImageUrl } from '../../utils/url';

interface ReviewProductsModalProps {
  open: boolean;
  onClose: () => void;
  orderId: number;
  products: StoreReviewableProduct[];
  onReviewed: (productId: number) => void;
}

export function ReviewProductsModal({ open, onClose, orderId, products, onReviewed }: ReviewProductsModalProps) {
  const { getForm, setRating, setComment, submit } = useReviewForm(orderId, onReviewed);

  return (
    <Modal open={open} onClose={onClose} title={`Avaliar produtos — Pedido #${orderId}`}>
      {products.length === 0 ? (
        <p className="text-sm text-text-light text-center py-4">
          Você já avaliou todos os produtos deste pedido.
        </p>
      ) : (
        <ul className="space-y-5">
          {products.map((product) => {
            const form = getForm(product.productId);
            return (
              <li key={product.productId} className="bg-champagne/30 rounded-xl p-4">
                <div className="flex items-center gap-3 mb-3">
                  {product.imageUrl ? (
                    <img
                      src={safeImageUrl(product.imageUrl)}
                      alt={product.productName}
                      className="w-12 h-12 rounded-lg object-cover bg-champagne shrink-0"
                    />
                  ) : (
                    <div className="w-12 h-12 rounded-lg bg-champagne shrink-0" />
                  )}
                  <p className="text-sm font-medium text-text-dark">{product.productName}</p>
                </div>

                <StarRating
                  value={form.rating}
                  onChange={(rating) => setRating(product.productId, rating)}
                  size="lg"
                />

                <textarea
                  value={form.comment}
                  onChange={(e) => setComment(product.productId, e.target.value)}
                  rows={2}
                  placeholder="Conte como foi sua experiência com o produto (opcional)"
                  className="w-full text-sm border border-champagne-dark rounded-xl px-3 py-2 mt-3 text-text-dark resize-none focus:outline-none focus:ring-1 focus:ring-chocolate/30"
                />

                <Button
                  size="sm"
                  variant="primary"
                  className="mt-3"
                  onClick={() => submit(product.productId)}
                  disabled={form.submitting}
                >
                  {form.submitting ? 'Enviando...' : 'Enviar avaliação'}
                </Button>
              </li>
            );
          })}
        </ul>
      )}
    </Modal>
  );
}
